import { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import api from "../../services/api";
import MoneyInput from "../../components/Custombb/MoneyInput";
import Swal from "sweetalert2";

const WalletChargeModal = ({
  show,
  onHide,
  targetType = "USER", // یا "CATEGORY"
  targetId,
  onSuccess,
}) => {
  const [form, setForm] = useState({
    amount: "",
    description: "",
    type: "CHARGE", // CHARGE | DEDUCT
    categoryId: null, // Product Category ID
  });
  const [loading, setLoading] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);

  useEffect(() => {
    fetchCategories(); // تابع جهت گرفتن دسته‌بندی‌ها
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await api.get('/merchant-categories?isActive=true');
      setCategoryOptions(response.data);
    } catch (err) {
      console.error('Failed to fetch categories', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!targetId) return Swal.fire({ icon: "error", title: "خطا", text: "شناسه هدف مشخص نیست" });

    setLoading(true);
    try {
      const url =
        targetType === "CATEGORY"
          ? `/admin/categories/${targetId}/wallet/charge`
          : `/admin/users/${targetId}/wallet/charge`;

      await api.post(url, form);
      Swal.fire({ icon: "success", title: "موفقیت", text: "عملیات با موفقیت انجام شد", timer: 2000, showConfirmButton: false });
      onHide();
      onSuccess?.();
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "خطا", text: err.response?.data?.message || "خطا در شارژ کیف پول" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>شارژ کیف پول {targetType === "CATEGORY" ? "دسته" : "کاربر"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>مبلغ (تومان)</Form.Label>
            <MoneyInput
              value={form.amount} // form.amount = "150000" (raw digits)
              onChange={(raw) => setForm({ ...form, amount: raw })}
              placeholder="مبلغ را وارد کنید"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>نوع عملیات</Form.Label>
            <Form.Select
              value={form.type}
              onChange={(e) => setForm({ ...form, type: e.target.value })}
            >
              <option value="CHARGE">شارژ کیف پول</option>
              <option value="DEDUCT">برداشت از کیف پول</option>
            </Form.Select>
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>انتخاب دسته‌بندی (اختیاری)</Form.Label>
            <Form.Select
              value={form.categoryId}
              onChange={(e) => setForm({ ...form, categoryId: e.target.value })}
            >
              <option value="">همه دسته‌ها</option>
              {categoryOptions.map((cat) => (
                <option key={cat.id} value={cat.id}>{cat.title}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>توضیحات (اختیاری)</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
            />
          </Form.Group>

          <div className="text-end">
            <Button variant="secondary" onClick={onHide} className="me-2">
              انصراف
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? <Spinner size="sm" /> : "تأیید"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default WalletChargeModal;
